"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.WixCodeForum = function (props) { return (React.createElement("svg", __assign({ width: "15", height: "19", viewBox: "0 -3 12 20" }, props),
    React.createElement("defs", null,
        React.createElement("polygon", { id: "path-1", points: "0.0155 0.1159 5.541 0.1159 5.541 5.9999 0.0155 5.9999" }),
        React.createElement("polygon", { id: "path-3", points: "0 0.1161 5.525 0.1161 5.525 6 0 6" })),
    React.createElement("g", { id: "Artboard" },
        React.createElement("g", { id: "Group-9" },
            React.createElement("g", { id: "Group-3", transform: "translate(6.000000, 9.384600)" },
                React.createElement("path", { d: "M3.7295,0.1159 C2.7295,0.9959 1.4375,1.5459 0.0155,1.6029 L1.8495,5.9999 L2.9255,3.3849 L5.5415,4.4599 L3.7295,0.1159 Z", id: "Fill-1", mask: "url(#mask-2)" })),
            React.createElement("g", { id: "Group-6", transform: "translate(0.000000, 9.384600)" },
                React.createElement("path", { d: "M0,4.4601 L2.616,3.3841 L3.692,6.0001 L5.525,1.6031 C4.104,1.5451 2.811,0.9961 1.812,0.1161 L0,4.4601 Z", id: "Fill-4", mask: "url(#mask-4)" })),
            React.createElement("path", { d: "M10.7705,5 C10.7705,2.243 8.5275,0 5.7705,0 C3.0135,0 0.7705,2.243 0.7705,5 C0.7705,6.371 1.3265,7.612 2.2225,8.517 C3.0895,9.392 4.2805,9.936 5.5965,9.982 C5.6555,9.984 5.7105,10 5.7705,10 C5.8305,10 5.8855,9.984 5.9445,9.982 C7.2605,9.936 8.4515,9.392 9.3185,8.517 C10.2145,7.612 10.7705,6.371 10.7705,5", id: "Fill-7" }))))); };
//# sourceMappingURL=wix-code-forum.js.map